export const LISTING_TABS_KEYS = {
  LISTING: 'LISTING',
  ANALYTICS: 'ANALYTICS',
  METRICS: 'METRICS',
};

const { LISTING, ANALYTICS, METRICS } = LISTING_TABS_KEYS;

export const LISTING_TABS_OPTIONS = {
  [LISTING]: {
    label: 'Listing',
    id: 'listing',
  },
  [ANALYTICS]: {
    label: 'Analytics',
    id: 'analytics',
  },
  [METRICS]: {
    label: 'Metrics summary',
    id: 'metrics',
  },
};
